import React, { useState, useRef, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import logo from 'assets/img/Logo-Humano.png';
import { Formik } from 'formik';
import { isBrowser } from "react-device-detect";
import { NavLink } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { get, post, patch, getAnonymous } from 'services';
import { connect } from 'react-redux';
import { SetUser } from "redux/actions/userActions";
import { SetLoggedIn } from "redux/actions/isLoggedInActions";
import { SetLoading } from "redux/actions/loadingActions";
import { useHistory } from "react-router";
import Spinner from 'react-bootstrap/Spinner';
import Linkedin from '../../assets/img/linked-in.png';
import { ToastContainer, toast } from 'react-toastify';
import ReactPasswordStrength from 'react-password-strength';
import 'react-toastify/dist/ReactToastify.css';

const sign = require('jwt-encode');
const Swal = require('sweetalert2');
let yup = require('yup');

const bigTitle = {
    width: '35%',
    borderBottom: '1px solid #005C97',
    lineHeight: '0.1em',
    margin: '10px 0 20px'
}

const bigTitleBg = {
    color: '#005C97',
    background: '#fff',
    padding: '0 10px'
}

const marginTopTen = {
    marginBottom: 10
}

const logoStyle = {
    ...marginTopTen,
    marginBottom: 10,
    width: 150,
    marginRight: 10
}

const minWidth = {
    minWidth: 1000,
    maxWidth: 1000
}

const loadingClases = {
    border: 'solid',
    borderRadius: '50%',
    borderRightColor: 'transparent'
}

const inputProps = (type) => {
    return {
        placeholder: "Escriba su contraseña...",
        autoFocus: false,
        className: 'another-input-prop-class-name',
        type
    }
};

const notify = (text) => toast.warn(text, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    });

const Register = (props) => {
    const history = useHistory();
    const [formContent, setFormContent] = useState({
        password: '',
        //confirmPassword: '',
        name: '',
        lastName: '',
        email: '',
    });
    const [reCAPTCHA, setReCAPTCHA] = useState('');
    const formRef = useRef();
    const schema = yup.object({
        password: yup.string().matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]){8,}/, "Debe poseer mínimo 8 carácteres, una mayúscula, una minúscula y un carácter especial").required('La contraseña es requerida'),
        name: yup.string().matches(/^[A-Za-zá-ýÁ-Ý\s]*$/, 'Debe ingresar un nombre válido').required('El nombre es requerido'),
        lastName: yup.string().matches(/^[A-Za-zá-ýÁ-Ý\s]*$/, 'Debe ingresar un apellido válido').required('El apellido es requerido'),
        email: yup.string().email("Debe ingresar un correo").required("El campo es requerido"),
    });
    const [lindekingUser, setLinkedingUser] = useState({});
    const [passwordType, setPasswordType] = useState('password');
    const [currentPassword, setCurrentPassword] = useState({});

    const setOnPasswordTypeClick = () => {
        if (passwordType == 'password') {
            setPasswordType('text')
        } else {
            setPasswordType('password')
        }
    }

    const setPassword = (password) => {
        setCurrentPassword(password)
    }

    useEffect(() => {

        const code = history.location.search;
        if (code && code.length > 0) {
            const result = code.split("?code=");
            if (result.length > 0) {
                const token = result[1];
                props.SetLoading(true);
               
                getAnonymous(`Usuario/Linkedin?token=${token}`)
                    .then(({ data }) => {
                        try {
                            const { access_token } = data;
                            setFields(access_token)
                        } catch (ex) {
                            console.log(ex);
                        }

                        props.SetLoading(false);
                    })
                    .catch(err => {
                        console.log("ERROR: ", err);
                        props.SetLoading(false);
                    }).finally(() => props.SetLoading(false));
            }
        }
    }, []);

    const setFields = async (access_token) => {
        try {
            const { data } = await get(`usuario/LinkedinFields?access_token=${access_token}`);
            const { deserializedE, deserialized } = data;
            const user = {
                email: deserializedE.elements[0]["handle~"].emailAddress,
                name: deserialized.localizedFirstName,
                lastName: deserialized.localizedLastName,
                image: deserialized.profilePicture["displayImage~"].elements[3].identifiers[0].identifier
            };
            setLinkedingUser(user);
            setFormContent({
                name: user.name,
                lastName: user.lastName,
                //confirmPassword: '',
                email: user.email,
                password: ''
            });
        } catch (error) {

        }
    }

    function isEmpty(obj) {
        for(var prop in obj) {
          if(obj.hasOwnProperty(prop)) {
            return false;
          }
        }
      
        return JSON.stringify(obj) === JSON.stringify({});
      }

    const onSumitted = async (data, { resetForm }) => {
        try {

            const exist = await validateIfUserExist();
            if (exist) {
                notify('El correo que intenta registrar no es válido');
                return;
            }

            // if (currentPassword.isValid) {
                props.SetLoading(true);
                let primerApellido = null;
                let segundoApellido = null;

                if (data.lastName.includes(" ")) {
                    const apellidos = data.lastName.split(" ");
                    primerApellido = apellidos[0]
                    segundoApellido =  apellidos[1]
                } else {
                    primerApellido = data.lastName;
                }

                const usuario = {
                    image: lindekingUser.image ? lindekingUser.image : '',
                    clave: data.password,
                    Persona: {
                        nombre: data.name,
                        apellido: data.lastName,
                        email: data.email,
                        primerApellido,
                        segundoApellido
                    },
                    recaptcha: reCAPTCHA,
                };
                
                const result = await post(`usuario/Registro`, usuario);
                
                if (result && result.data) {
                    Swal.fire({
                        icon: 'success',
                        title: '¡Usuario registrado correctamente!',
                        text: 'Favor ingresar a su correo para validar su cuenta'
                    });
                    
                    history.push({
                        pathname: "/",
                        state: {}
                    });
                }

            // } else {
            //     notify('¡La contraseña no cumple los requerimientos!');
            // }
        } catch (error) {
            console.log(error);
        } finally {
            props.SetLoading(false);
        }
    }

    const fnLinkedin = async () => {
        try {
            props.SetLoading(true);
            const uri = `${process.env.REACT_APP_LINKEDIN_BASE_API}/authorization?response_type=code&client_id=${process.env.REACT_APP_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_REDIRECT_URI}&scope=r_liteprofile%20r_emailaddress%20w_member_social`
            window.location.href = uri;
            props.SetLoading(false);
        } catch (error) {
            console.log(error);
        } finally {
            props.SetLoading(false);
        }
    }

    const validateIfUserExist = async () => {
        try {
            props.SetLoading(true);
            const oldValues = formRef.current.values;
            const dto = await get(`Usuario/ValidateIfUserExist?user=${oldValues.email}`);
            props.SetLoading(false);
            const data = dto.data;
            if (data.usuario && data.usuario.nombre) {
                if (data.usuario.nombre != oldValues.name && data.usuario.apellido != oldValues.lastName) {
                    Swal.fire({
                        icon: 'warning',
                        title: '¡Atención!',
                        text: '¡Se ha encontrado un usuario con ese correo electrónico, se recomienda volver al login e ingresar ó recuperar contraseña en caso de no recordarla!'
                    });
                }
                oldValues.name = data.usuario.nombre;
                oldValues.lastName = data.usuario.apellido;
                setFormContent(() => {
                    return {
                        ...oldValues
                    }
                });
                return true;
            }
            return false;
        } catch (error) {
            console.log(error);
        } finally {
            props.SetLoading(false);
        }
    }

    return (
        <>
            <ToastContainer />
            {
                props.loading &&
                <div className={'display-flex flex-direction-row flex-center'}>
                    <Spinner style={loadingClases} variant="primary" className={'is-absolute center-spinner-vertically'} animation="border" size="lg" />
                </div>
            }
            <div className="display-flex flex-center center-vertical flex-direction-column height-100 login-background">

                <div className={'padding-10'}>

                    <div style={!isBrowser ? {marginTop: 120} : null } className={'display-flex flex-end'}>
                        <img style={logoStyle} src={logo} alt="logo" />
                    </div>

                    <Card className="card-login">
                        <Card.Body style={isBrowser ? minWidth : null} className={'padding-10'}>
                            {
                                //(!verifyCode) ?
                                <Formik
                                    innerRef={formRef}
                                    validationSchema={schema}
                                    onSubmit={onSumitted}
                                    initialValues={formContent}
                                    enableReinitialize={true}
                                    validateOnChange={false}
                                    validateOnBlur={false}
                                >
                                    {({
                                        handleSubmit,
                                        handleChange,
                                        handleBlur,
                                        values,
                                        touched,
                                        isValid,
                                        errors,
                                        setFieldValue
                                    }) => (
                                        <Form noValidate autoComplete="off" onSubmit={handleSubmit}>

                                            <Form.Row>

                                                <Form.Group as={Col} md="12" controlId="validationFormik012">
                                                    <h4> <b> <span style={{color: '#005C97'}}> Regístrate </span> </b> </h4>

                                                </Form.Group>

                                                <Form.Group as={Col} md="6" controlId="validationFormik012">
                                                    <Form.Label> <strong> Nombre </strong> </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="name"
                                                        value={values.name}
                                                        onChange={handleChange}
                                                        isValid={touched.name && !errors.name}
                                                        isInvalid={!!errors.name}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.name}
                                                    </Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group as={Col} md="6" controlId="validationFormik02">
                                                    <Form.Label> <strong> Apellido </strong> </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="lastName"
                                                        value={values.lastName}
                                                        onChange={handleChange}
                                                        isValid={touched.lastName && !errors.lastName}
                                                        isInvalid={!!errors.lastName}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.lastName}
                                                    </Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group as={Col} md="6" controlId="validationFormik02">
                                                    <Form.Label> <strong> Correo </strong> </Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        name="email"
                                                        value={values.email}
                                                        onChange={handleChange}
                                                        isValid={touched.email && !errors.email}
                                                        isInvalid={!!errors.email}
                                                        onBlur={validateIfUserExist}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.email}
                                                    </Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group as={Col} md="6" controlId="validationFormik02">
                                                    <Form.Label> <strong> Contraseña </strong> </Form.Label>
                                                    <Form.Control
                                                       className="is-password"
                                                        type="text"
                                                        name="password"
                                                        value={values.password}
                                                        onChange={handleChange}
                                                        isValid={touched.password && !errors.password}
                                                        isInvalid={!!errors.password}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.password}
                                                    </Form.Control.Feedback>
                                                </Form.Group>

                                                {/* 

                                                <Form.Group as={Col} md="4" controlId="validationFormik02">
                                                    <Form.Label> <strong> Confirmar contraseña </strong> </Form.Label>
                                                    <Form.Control
                                                        className="is-password"
                                                        type="text"
                                                        name="confirmPassword"
                                                        value={values.confirmPassword}
                                                        onChange={handleChange}
                                                        isValid={touched.confirmPassword && !errors.confirmPassword}
                                                        isInvalid={!!errors.confirmPassword}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.confirmPassword}
                                                    </Form.Control.Feedback>
                                                </Form.Group> */}
                                                
                                                {/* <Form.Group as={Col} md="4" controlId="validationFormik02">
                                                    <Form.Label> <strong> Contraseña </strong> </Form.Label>
                                                    <ReactPasswordStrength
                                                        style={{borderRadius: 5}}
                                                        tooShortWord={'deficiente'} 
                                                        minLength={3}
                                                        minScore={2}
                                                        scoreWords={['deficiente', 'débil', 'regular', 'regular', 'buena']}
                                                        inputProps={{ ...inputProps(passwordType), id: 'inputPassword' }}
                                                        changeCallback={setPassword}
                                                    />
                                                </Form.Group> */}

                                                {/* <Form.Group as={Col} md="2" controlId="validationFormik02">
                                                    {
                                                        passwordType === 'password' 
                                                        ? <Button style={{ marginTop: isBrowser ? '44px' : '' }} onClick={setOnPasswordTypeClick} variant={'info'}>
                                                                Mostrar contraseña
                                                            </Button> 
                                                        : <Button style={{ marginTop: isBrowser ? '44px' : '' }} onClick={setOnPasswordTypeClick} variant={'danger'}>
                                                                Ocultar contraseña
                                                        </Button>
                                                    }
                                                </Form.Group> */}

                                            </Form.Row>

                                            <ReCAPTCHA
                                                sitekey={process.env.REACT_APP_NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                                                onChange={setReCAPTCHA}
                                                hl={'es'}
                                            />
                                            
                                            <div style={marginTopTen} className={'display-flex flex-end-vertical'}>
                                                <NavLink
                                                    to="/SolicitudEmpleo/IniciarSesion"
                                                    exact
                                                >
                                                    Volver al login
                                                </NavLink>
                                            </div>

                                            <div className={'display-flex flex-direction-column center-vertical'}>
                                                <Button style={{width: '35%'}} disabled={reCAPTCHA == ''} variant={'dark'} type="submit">
                                                    <span style={{fontSize:20}}> 
                                                        <strong> 
                                                            Acceder 
                                                        </strong> 
                                                    </span>
                                                </Button>
                                                
                                                <br/>
                                                
                                                <div style={bigTitle}>
                                                    <center>
                                                        <span style={bigTitleBg}>
                                                            <b> o acceder con </b>
                                                        </span>
                                                    </center>
                                                </div>

                                                <Button style={{width: '35%', marginTop: 10}} variant={'primary'} onClick={fnLinkedin}>
                                                    <strong> Tu cuenta de LinkedIn </strong> 
                                                    <img  src={Linkedin} width={20} alt="Linkedin" /> 
                                                </Button>

                                                {/* <img className="mr-4 is-clickable" onClick={fnLinkedin} src={Linkedin} width={100} alt="Registrarme con linkedin" /> */}
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                            }

                        </Card.Body>
                    </Card>

                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        loading: state.loading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        SetUser: (user) => dispatch(SetUser(user)),
        SetLoggedIn: (value) => dispatch(SetLoggedIn(value)),
        SetLoading: (value) => dispatch(SetLoading(value))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps)(Register);

